// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".command-bar-results{border-top:1px solid var(--border);padding-top:1rem}.command-bar-results__empty span{display:flex;justify-content:center;color:var(--body-2)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
